import { PendingApproval } from './auth/Devices';
import { LoginForm } from './auth/LoginForm';
import { SignedIn } from './auth/SignedIn';
import { useAuth } from './auth/store';
import { DossiersPage } from './dossiers/DossiersPage';

export function App() {
  const session = useAuth((s) => s.session);
  const device = useAuth((s) => s.device);
  const pending = useAuth((s) => s.pendingDevice);
  const tenantSlug = useAuth((s) => s.tenantSlug);
  const email = useAuth((s) => s.email);

  if (!session) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <div className="max-w-2xl px-6 py-12 text-center">
          <Brand />
          <p className="mt-6 text-lg text-slate-600">
            Espace de travail sécurisé entre avocats et clients — chiffrement de
            bout en bout, structure par dossier, audit trail exploitable en
            défense disciplinaire.
          </p>
          <LoginForm />
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen">
      <div className="mx-auto max-w-5xl px-6 py-10">
        <Brand />

        {/* Cet appareil attend d'être approuvé : sans identité MLS, il ne peut
            rejoindre aucun dossier. */}
        {pending && <PendingApproval tenantSlug={tenantSlug} email={email} />}

        {device && <DossiersPage />}

        <div className="mt-12 border-t border-slate-200 pt-8">
          <SignedIn />
        </div>
      </div>
    </main>
  );
}

function Brand() {
  return (
    <>
      <p className="text-sm font-medium uppercase tracking-widest text-blue-900">
        Altekk
      </p>
      <h1 className="mt-1 text-3xl font-semibold text-slate-900">Delo</h1>
    </>
  );
}
